import { Box } from '@mui/material';
import { type ReactElement } from 'react';

import { HealthLevelIcon } from '../../components/general/HealthIcon/HealthLevelIcon.tsx';
import { GetHealthByVeranstaltungOutput } from '../../dtos';

type FehlerCellProps = {
  healthFindings: GetHealthByVeranstaltungOutput | undefined;
};

export const FehlerCell = ({ healthFindings }: FehlerCellProps): ReactElement => (
  <Box display="flex" justifyContent="center" height="100%" alignItems="center">
    <HealthLevelIcon healthLevels={healthFindings?.map((item) => item.type)} />
  </Box>
);
